/**
 * flags.js
 *
 * @description Defines feature flags. See the bottom of this file for defined flags.
 */

/**
 * A FeatureFlag provides a safe way to test a feature in production
 * without impacting customers.
 *
 * Define your feature flag in this file and then either:
 *
 * To test on nightly.owal.io: Add the identifier to /config/dev.env.js.
 * To test in production: Add the identifier to /config/prod.env.js
 *
 * To use your flag, import it then call `.enabled` to check if it's enabled.
 *
 * In both cases you will need to restart the app with yarn (or npm.)
 *
 * Feature flags are intended to be used temporarily as gates for in development features
 * and are not intended to be left in the codebase permanently.
 * @class FeatureFlag
 */

import { FeatureFlag } from './featureFlag'

export const CamerasPage = new FeatureFlag('VUE_APP_OWAL_ENABLE_CAMERAS_PAGE', ['The cameras list', 'Nov 2, 2017'])
export const AddCamera = new FeatureFlag('VUE_APP_OWAL_ENABLE_ADD_CAMERA', ['The add cameras page', 'Nov 2, 2017'])
export const AlertSettings = new FeatureFlag('VUE_APP_OWAL_ENABLE_ALERT_SETTINGS', ['The add alerts page', 'Jan 17, 2018'])
export const FallbackToTestStream = new FeatureFlag('VUE_APP_OWAL_ENABLE_HLS_TEST_STREAM', ['Use a fallback stream to test HLS if real server fails.', 'March 19, 2018'])
export const DemoDataForFaces = new FeatureFlag('VUE_APP_OWAL_ENABLE_DUMMY_DATA', ['Show fake names in Faces.', 'March 9, 2018'])
export const DevEndpoint = new FeatureFlag('VUE_APP_OWAL_ENABLE_DEV_ENPOINT', ['Use yakov.owal.io as root API endpoint.', 'March 16, 2018'])
